<template>
  <div class="position-map">
    <img src="@/assets/images/usmap.png" alt="U.S. map" class="map" />
    <div
      class="marker"
      :class="item.className"
      v-for="(item, index) in $t('markerList')"
      :key="index"
    >
      <div class="icon" @click="showInfo = item.className">
        <img
          src="@/assets/images/logo.svg"
          :alt="item.p1 + ', ' + item.p2"
          :title="item.p1 + ', ' + item.p2"
        />
      </div>
      <div
        v-if="showInfo === item.className && item.className === 'marker1'"
        class="marker1-special"
      >
        <h3>{{ item.name }}</h3>
        <a :href="item.gmap" target="_blank">{{ item.p1 }}</a>
        <a :href="item.gmap1" target="_blank">{{ item.p2 }}</a>
      </div>
      <a
        :href="item.gmap"
        class="info"
        v-if="showInfo === item.className && item.className !== 'marker1'"
        target="_blank"
      >
        <h3>{{ item.name }}</h3>
        <p v-if="item.p1">{{ item.p1 }}</p>
        <p v-if="item.p2">{{ item.p2 }}</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'positionMap',
  data() {
    return {
      showInfo: 'marker1'
    }
  }
}
</script>

<style scoped lang="scss">
.position-map {
  position: relative;

  .map {
    display: block;
    width: 100%;
  }

  .marker {
    position: absolute;

    .icon {
      width: 40px;
      height: 22px;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .marker1-special {
      position: absolute;
      left: 0;
      top: 30px;
      padding: 10px 20px;
      background: #e50012;
      border-radius: 10px;
      width: 316px;
      color: #f7f4f3;
      text-align: center;
      z-index: 1;

      h3 {
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 150%;
        margin-bottom: 8px;
      }
      & > a {
        display: block;
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        color: #f7f4f3;
      }
    }

    .info {
      position: absolute;
      left: 0;
      top: 30px;
      padding: 10px 20px;
      background: #e50012;
      border-radius: 10px;
      width: 200px;
      color: #f7f4f3;
      z-index: 1;

      h3 {
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 150%;
        margin-bottom: 8px;
      }

      p {
        font-family: 'PingFang HK';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
      }
    }
  }

  .marker.marker1 {
    top: 200px;
    left: 115px;
  }

  .marker.marker2 {
    top: 140px;
    left: 95px;
  }

  .marker.marker3 {
    top: 140px;
    right: 230px;
  }

  .marker.marker4 {
    right: 290px;
    bottom: 95px;
  }

  .marker.marker5 {
    right: 70px;
    top: 110px;
  }

  .marker.marker6 {
    right: 102px;
    top: 218px;
  }
}

@media only screen and (max-width: 767px) {
  .position-map .marker3 .info {
    right: 0;
    left: auto;
  }

  .position-map .marker .info {
    -webkit-transform-origin: 50% 0;
    -moz-transform-origin: 50% 0;
    -ms-transform-origin: 50% 0;
    -o-transform-origin: 50% 0;
    transform-origin: 50% 0;
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
    z-index: 5;
  }

  .position-map .marker .icon {
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
    transform: scale(2);
  }
}
</style>
